import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ClientViewLayout from "./ClientViewLayout";
import { CLIENT_VIEWS, clientViewRoute, type ClientViewDef } from "./config";

// Rutas de la vista del cliente (CC-CONSOLE #981): una por app, con la misma
// URL que en CC-CONSOLE y la sección por defecto como índice.
const routeFor = (v: ClientViewDef): RouteObject => {
  const index: RouteObject = { index: true, element: <Navigate to={clientViewRoute(v)} replace /> };
  const section: RouteObject = { path: v.item, element: <v.Section /> };
  return { path: v.base, element: <ClientViewLayout />, children: [index, section] };
};

export const clientViewRoutes: RouteObject[] = CLIENT_VIEWS.map(routeFor);
